// These icons need further customizations (below the exports)
import pollIcon from '@mingcute/icons/core-regular/chart-bar';
import popinIcon from '@mingcute/icons/core-regular/external-link';
import unblockIcon from '@mingcute/icons/core-regular/forbid-circle';
import moonIcon from '@mingcute/icons/core-regular/moon';
import unpinIcon from '@mingcute/icons/core-regular/pin';
import replyIcon from '@mingcute/icons/core-regular/share-forward';

// These icons don't need further customizations, use as-is
export { default as x } from '@mingcute/icons/core-regular/close';
export { default as heart } from '@mingcute/icons/core-regular/heart';
export { default as bookmark } from '@mingcute/icons/core-regular/bookmark';
export { default as 'check-circle' } from '@mingcute/icons/core-regular/check-circle';
export { default as 'x-circle' } from '@mingcute/icons/core-regular/close-circle';
export { default as transfer } from '@mingcute/icons/core-regular/transfer-4';
export { default as rocket } from '@mingcute/icons/core-regular/rocket';
export { default as 'arrow-left' } from '@mingcute/icons/core-regular/arrow-left';
export { default as 'arrow-right' } from '@mingcute/icons/core-regular/arrow-right';
export { default as 'arrow-up' } from '@mingcute/icons/core-regular/arrow-up';
export { default as 'arrow-down' } from '@mingcute/icons/core-regular/arrow-down';
export { default as earth } from '@mingcute/icons/core-regular/world-2';
export { default as lock } from '@mingcute/icons/core-regular/lock';
export { default as unlock } from '@mingcute/icons/core-regular/unlock';
export { default as 'eye-close' } from '@mingcute/icons/core-regular/eye-close';
export { default as 'eye-open' } from '@mingcute/icons/core-regular/eye-2';
export { default as message } from '@mingcute/icons/core-regular/mail';
export { default as comment } from '@mingcute/icons/core-regular/chat-3';
export { default as comment2 } from '@mingcute/icons/core-regular/comment-2';
export { default as home } from '@mingcute/icons/core-regular/home-3';
export { default as notification } from '@mingcute/icons/core-regular/notification';
export { default as follow } from '@mingcute/icons/core-regular/user-follow';
export { default as 'follow-add' } from '@mingcute/icons/core-regular/user-add';
export { default as pencil } from '@mingcute/icons/core-regular/pencil';
export { default as quill } from '@mingcute/icons/core-regular/quill-pen';
export { default as at } from '@mingcute/icons/core-regular/at';
export { default as attachment } from '@mingcute/icons/core-regular/attachment';
export { default as upload } from '@mingcute/icons/core-regular/upload-3';
export { default as gear } from '@mingcute/icons/core-regular/settings-3';
export { default as more } from '@mingcute/icons/core-regular/more-3';
export { default as more2 } from '@mingcute/icons/core-filled/more-1';
export { default as external } from '@mingcute/icons/core-regular/external-link';
export { default as popout } from '@mingcute/icons/core-regular/external-link';
export { default as plus } from '@mingcute/icons/core-regular/add-circle';
export { default as 'chevron-left' } from '@mingcute/icons/core-regular/left';
export { default as 'chevron-right' } from '@mingcute/icons/core-regular/right';
export { default as 'chevron-down' } from '@mingcute/icons/core-regular/down';
export { default as thread } from '@mingcute/icons/core-regular/route';
export { default as group } from '@mingcute/icons/core-regular/group';
export { default as bot } from '@mingcute/icons/core-regular/android-2';
export { default as menu } from '@mingcute/icons/core-regular/rows-4';
export { default as list } from '@mingcute/icons/core-regular/list-check';
export { default as search } from '@mingcute/icons/core-regular/search-2';
export { default as hashtag } from '@mingcute/icons/core-regular/hashtag';
export { default as info } from '@mingcute/icons/core-regular/information';
export { default as question } from '@mingcute/icons/core-regular/question';
export { default as shortcut } from '@mingcute/icons/core-regular/lightning';
export { default as user } from '@mingcute/icons/core-regular/user-4';
export { default as following } from '@mingcute/icons/core-regular/walk';
export { default as pin } from '@mingcute/icons/core-regular/pin';
export { default as bus } from '@mingcute/icons/core-regular/bus-2';
export { default as link } from '@mingcute/icons/core-regular/link-2';
export { default as history } from '@mingcute/icons/core-regular/history';
export { default as share } from '@mingcute/icons/core-regular/share-2';
export { default as sparkles } from '@mingcute/icons/core-regular/sparkles';
export { default as sparkles2 } from '@mingcute/icons/core-regular/sparkles-2';
export { default as exit } from '@mingcute/icons/core-regular/exit';
export { default as translate } from '@mingcute/icons/core-regular/translate';
export { default as play } from '@mingcute/icons/core-filled/play';
export { default as trash } from '@mingcute/icons/core-regular/delete-2';
export { default as mute } from '@mingcute/icons/core-regular/volume-mute';
export { default as unmute } from '@mingcute/icons/core-regular/volume';
export { default as block } from '@mingcute/icons/core-regular/forbid-circle';
export { default as flag } from '@mingcute/icons/core-regular/flag-1';
export { default as time } from '@mingcute/icons/core-regular/time';
export { default as refresh } from '@mingcute/icons/core-regular/refresh-2';
export { default as emoji2 } from '@mingcute/icons/core-regular/emoji-2';
export { default as filter } from '@mingcute/icons/core-regular/filter-2';
export { default as filters } from '@mingcute/icons/core-regular/filter';
export { default as chart } from '@mingcute/icons/core-regular/chart-line';
export { default as react } from '@mingcute/icons/core-regular/react';
export { default as layout4 } from '@mingcute/icons/core-regular/layout-4';
export { default as layout5 } from '@mingcute/icons/core-regular/layout-5';
export { default as announce } from '@mingcute/icons/core-regular/announcement';
export { default as alert } from '@mingcute/icons/core-regular/alert';
export { default as round } from '@mingcute/icons/core-filled/round';
export { default as 'round-line' } from '@mingcute/icons/core-regular/round';
export { default as 'arrow-up-circle' } from '@mingcute/icons/core-regular/arrow-up-circle';
export { default as 'arrow-down-circle' } from '@mingcute/icons/core-regular/arrow-down-circle';
export { default as clipboard } from '@mingcute/icons/core-regular/clipboard';
export { default as 'account-edit' } from '@mingcute/icons/core-regular/user-edit';
export { default as 'account-warning' } from '@mingcute/icons/core-regular/user-warning';
export { default as 'account-add' } from '@mingcute/icons/core-regular/user-add-2';
export { default as keyboard } from '@mingcute/icons/core-regular/keyboard';
export { default as cloud } from '@mingcute/icons/core-regular/cloud';
export { default as month } from '@mingcute/icons/core-regular/calendar-month';
export { default as media } from '@mingcute/icons/core-regular/photo-album';
export { default as speak } from '@mingcute/icons/core-regular/radar-2';
export { default as building } from '@mingcute/icons/core-regular/building-5';
export { default as history2 } from '@mingcute/icons/core-regular/history-2';
export { default as document } from '@mingcute/icons/core-regular/document-2';
export { default as 'arrows-right' } from '@mingcute/icons/core-regular/arrows-right';
export { default as code } from '@mingcute/icons/core-regular/code';
export { default as copy } from '@mingcute/icons/core-regular/copy-2';
export { default as quote } from '@mingcute/icons/core-filled/quote-left';
export { default as quote2 } from '@mingcute/icons/core-regular/blockquote';
export { default as settings } from '@mingcute/icons/core-regular/settings-6';
export { default as 'heart-break' } from '@mingcute/icons/core-regular/heart-crack';
export { default as 'user-x' } from '@mingcute/icons/core-regular/user-x';
export { default as minimize } from '@mingcute/icons/core-regular/minimize';
export { default as celebrate } from '@mingcute/icons/core-regular/celebrate';
export { default as schedule } from '@mingcute/icons/core-regular/calendar-time-add';
export { default as day } from '@mingcute/icons/core-regular/calendar-day';
export { default as camera } from '@mingcute/icons/core-regular/camera';
export { default as endorsement } from '@mingcute/icons/core-regular/user-star';
export { default as formula } from '@mingcute/icons/core-regular/formula';
export { default as edit } from '@mingcute/icons/core-regular/edit-4';
export { default as 'zoom-in' } from '@mingcute/icons/core-regular/zoom-in';
export { default as 'zoom-out' } from '@mingcute/icons/core-regular/zoom-out';
export { default as 'cursor-hand' } from '@mingcute/icons/core-regular/hand-finger-2';
export { default as qrcode } from '@mingcute/icons/core-regular/qrcode-2';
export { default as scan } from '@mingcute/icons/core-regular/scan';
export { default as note } from '@mingcute/icons/core-regular/document-3';
export { default as grid } from '@mingcute/icons/core-regular/grid';
export { default as 'arrow-up-top' } from '@mingcute/icons/core-regular/arrow-to-up';
export { default as collections } from '@mingcute/icons/core-regular/board';

// Here's the customizations
export const poll = { module: pollIcon, rotate: '90deg' };
export const popin = { module: popinIcon, rotate: '180deg' };
export const reply = {
  module: replyIcon,
  rotate: '180deg',
  flip: 'horizontal',
};
export const unpin = { module: unpinIcon, rotate: '180deg' };
export const unblock = { module: unblockIcon, rotate: '180deg' };
export const moon = { module: moonIcon, flip: 'horizontal' };

// Auto-flip in RTL layouts
export const RTL_ICONS = new Set([
  'announce',
  'arrow-left',
  'arrow-right',
  'arrows-right',
  'chevron-left',
  'chevron-right',
  'clipboard',
  'comment',
  'comment2',
  'endorsement',
  'exit',
  'external',
  'group',
  'history2',
  'layout4',
  'list',
  'month',
  'mute',
  'popin',
  'popout',
  'quote',
  'quote2',
  'reply',
  'unmute',
]);
